window.dtAbsenceApprovalMatrix = function () {
  const dt_absence_approval_matrix = new DataTable('#absence-approval-matrix-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#absence-approval-matrix-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#absence-approval-matrix-datatable', 8); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "leader_name" },
      { "data": "leader_ln" },
      { "data": "employee_count" },
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(2)', row).attr('colspan', 2);
      $('td:eq(3)', row).remove()
    },
  });

  dtFinalTouch()
}